import * as h2Api from '../../h2Api'
import { browserHistory } from '../../Routes'

export const SELECT_EDUCATION = 'BUDGET_SELECT_EDUCATION'
export const SELECT_CLUSTER = 'BUDGET_SELECT_CLUSTER'
export const SAVE_BUDGET_SERVER = 'BUDGET_SAVE_SERVER'
export const SELECT_ROUND = 'BUDGET_BUDGET_ROUND'
export const SET_CREDIT_AMOUNT = 'BUDGET_SET_CREDIT_AMOUNT'
export const SELECT_OPTION = 'BUDGET_SELECT_OPTION'
export const UNSELECT_OPTION = 'BUDGET_UNSELECT_OPTION'
export const SET_COMPLETED = 'BUDGET_SET_COMPLETED'
export const RESET_BUDGET = 'BUDGET_RESET_BUDGET'

export const selectEducation = jz => dispatch => {
  return dispatch({ type: SELECT_EDUCATION, jobZone: jz })
}

export const moveNext = (r, maxRounds) => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId
  const f = dispatch(
    h2Api.put(
      `/early/${loadedGameId}/budget`,
      getState().early.budget
    )({ type: SAVE_BUDGET_SERVER })
  )

  f.then(() => {
    if (r === maxRounds) {
      browserHistory.push(`/early/game/${loadedGameId}/budget/summary`)
    } else {
      const newId = r + 1

      dispatch(setBudgetRound(newId)).then(() =>
        browserHistory.push(`/early/game/${loadedGameId}/budget/round/${newId}`)
      )
    }
  })
}

export const movePrev = r => (dispatch, getState) => {
  const newId = r - 1
  const loadedGameId = getState().early.gameboard.loadedGameId
  const f = dispatch(
    h2Api.put(
      `/early/${loadedGameId}/budget`,
      getState().early.budget
    )({ type: SAVE_BUDGET_SERVER })
  )

  f.then(() => {
    if (newId == 0) {
      browserHistory.push(`/early/game/${loadedGameId}/budget/menu`)
    } else {
      dispatch(setBudgetRound(newId)).then(() =>
        browserHistory.push(`/early/game/${loadedGameId}/budget/round/${newId}`)
      )
    }
  })
}

export const selectOption = (round, o) => dispatch => {
  return dispatch({ type: SELECT_OPTION, round, choiceId: o.id, cost: o.cost })
}

export const unselectOption = (round, o) => dispatch => {
  return dispatch({ type: UNSELECT_OPTION, round, choiceId: o.id, cost: o.cost })
}

export const selectCluster = c => dispatch => {
  return dispatch({ type: SELECT_CLUSTER, clusterId: c })
}

export const setBudgetRound = r => dispatch => {
  return Promise.resolve(dispatch({ type: SELECT_ROUND, roundId: r }))
}

export const setCompleted = () => (dispatch, getState) => {
  const isCompleted = !!getState().early.budget.completedAt

  if (!isCompleted) {
    return Promise.resolve(
      dispatch({ type: SET_COMPLETED, dateCompleted: new Date() })
    ).then(() =>
      dispatch(
        h2Api.put(
          `/early/${loadedGameId}/budget`,
          getState().early.budget
        )({ type: SAVE_BUDGET_SERVER })
      )
    )
  }

  return Promise.resolve(true)
}

export const clickLifeSkillsSpinner = () => (dispatch, getState) => {}

export const clickPresentationSpinner = () => (dispatch, getState) => {
  const gb = getState().early.gameboard
  const levelId = gb.progress.levelId
  const loadedGameId = gb.loadedGameId

  if (levelId >= 3) {
    browserHistory.push(`/early/game/${loadedGameId}/presentation/home`)
  } else {
    alert('To access the presentation, you must first advance to level 3.')
  }
}

export const clickBudgetSpinner = () => (dispatch, getState) => {
  const gb = getState().early.gameboard
  const levelId = gb.progress.levelId
  const loadedGameId = gb.loadedGameId

  if (levelId >= 2) {
    browserHistory.push(`/early/game/${loadedGameId}/budget/menu`)
  } else {
    alert(
      'To access the budget, you must first advance to level 2. Rate some pathways and occupations to advance levels.'
    )
  }
}

const maxCredits = 300

export const setCredits = r => (dispatch, getState) => {
  const clusterCache = getState().clusterProfile.clusterCache
  const clusterId = getState().early.budget.clusterId
  const cluster = clusterCache[clusterId]
  const bAmount =
    cluster && cluster.hasOwnProperty('wages')
      ? calculateCredits(cluster.wages[0].average)
      : maxCredits / 3

  return Promise.resolve(dispatch({ type: SET_CREDIT_AMOUNT, amount: bAmount }))
}

export const calculateCredits = c => {
  return Math.min(Math.round((maxCredits * c) / 200000), maxCredits)
}

export const calculateDollars = c => {
  return Math.min(Math.round((200000 * c) / maxCredits), 200000)
}

export const resetBudget = b => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId

  return dispatch(
    h2Api.post(`/early/${loadedGameId}/budget/clear`, {})({ type: RESET_BUDGET })
  )
}
